// extracted by mini-css-extract-plugin
module.exports = {"reportsIcons":"ReportCard_reportsIcons__2UERy","timesSign":"ReportCard_timesSign__od2wU","eyeSign":"ReportCard_eyeSign__3wAOJ","bgColorReport":"ReportCard_bgColorReport__8Rsz2"};